module.exports = __webpack_public_path__ + "static/img/DSC_002.73d8ae08.png";